import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

export const getPicksEmptySubtitle = (): string =>
  `Waiting for matches to be released. They will appear here once the ${getWcBrand().NAME} schedule is synced.`;

export const ITEM_TYPE_HEADER = 'header' as const;
export const ITEM_TYPE_DATE_HEADER = 'dateHeader' as const;
export const ITEM_TYPE_MATCH = 'match' as const;

/** Pill tabs: time-first picks list (not group taxonomy). */
export const PICKS_TIME_TAB = {
  UPCOMING: 'upcoming',
  FINISHED: 'finished',
} as const;

export type PicksTimeTabKey = (typeof PICKS_TIME_TAB)[keyof typeof PICKS_TIME_TAB];

export const PICKS_VIEW_COPY = {
  EMPTY_ICON: '\u26BD',
  EMPTY_TITLE: 'No matches yet',
  TAB_UPCOMING: 'Upcoming',
  TAB_FINISHED: 'Finished',
  EMPTY_UPCOMING_TITLE: 'No upcoming matches',
  EMPTY_UPCOMING_SUBTITLE: 'Finished games are under the Finished tab.',
  EMPTY_FINISHED_TITLE: 'No finished matches yet',
  EMPTY_FINISHED_SUBTITLE: 'Your results will show here after games are played.',
  /** Shown with ActivityIndicator when React Query refetches in the background (matches already loaded). */
  LIVE_UPDATING: 'Live',
  ERROR_TITLE: "Couldn't load matches",
  ERROR_SUBTITLE: 'Check your connection and try again.',
  ERROR_RETRY: 'Try again',
} as const;

export const AUTOFILL_PICKS_TEST_ID = 'worldcup-picks-autofill-button';

/** Copy for the "Autofill picks" (reveal monkey picks) control + confirmation. */
export const AUTOFILL_PICKS_COPY = {
  TITLE: 'Autofill my picks',
  /** `{count}` replaced with the number of revealable picks. */
  SUBTITLE: (count: number) =>
    count === 1
      ? 'Lock in the 1 pick already assigned to you'
      : `Lock in the ${count} picks already assigned to you`,
  CONFIRM_TITLE: 'Autofill your picks?',
  CONFIRM_MESSAGE:
    "We'll reveal the picks already assigned to you for every match you haven't predicted yet, and make them yours. You can still edit any of them before kickoff.",
  CONFIRM_CTA: 'Autofill',
  CONFIRM_CANCEL: 'Cancel',
  ERROR_TITLE: "Couldn't autofill your picks",
  ERROR_MESSAGE: 'Something went wrong. Please try again.',
} as const;

import { Clock, CheckCircle } from 'lucide-react-native';
import type { AnimatedSegmentOption } from '../../ui/AnimatedSegmentedControl/AnimatedSegmentedControl';

export const TIME_TABS: AnimatedSegmentOption<PicksTimeTabKey>[] = [
  { key: PICKS_TIME_TAB.UPCOMING, label: PICKS_VIEW_COPY.TAB_UPCOMING, icon: Clock },
  { key: PICKS_TIME_TAB.FINISHED, label: PICKS_VIEW_COPY.TAB_FINISHED, icon: CheckCircle },
];
